import moment from 'moment-timezone'

/**
 * Formats a Date object to a DD/MM/YYYY string.
 */
export function formatDateToBR(date: Date): string {
  return moment.utc(date).format('DD/MM/YYYY')
}
